import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { GroupDTO, GroupProxy } from 'src/app/shared/proxies';

@Injectable()
export class GroupResolver implements Resolve<GroupDTO> {
    constructor(private groupProxy: GroupProxy) {}

    async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<GroupDTO> {
        const groupId = route.paramMap.get('groupId');
        return await this.groupProxy.getGroup(groupId);
    }
}
